<form [formGroup]="form" modalContainer invisibleWhitespace>
  <app-modal-header header (close)="close()"
    >템플릿 {{ documentTemplateId() ? '수정' : '등록' }}</app-modal-header
  >
  <div class="flex flex-col w-[60rem]">
    <div class="flex gap-3 items-start p-4">
      <app-select
        required
        label="카테고리"
        bindLabel="name"
        bindValue="id"
        formControlName="categoryId"
        [options]="categories() || []"
        placeholder="카테고리를 선택해주세요."
      />
      <app-input
        required
        class="w-full"
        label="문서명"
        formControlName="name"
        placeholder="문서명을 입력해주세요."
      />
    </div>
    <div class="p-4 bg-gray-50 w-full">
      <app-smart-editor
        class="w-full"
        [(oEditors)]="oEditors"
        [updateContent]="documentTemplate()?.content || ''"
      />
    </div>
  </div>
  <div footer class="p-4 border-t border-gray-100">
    <div class="flex w-full justify-end">
      <app-button (click)="submit()" [disabled]="form.invalid">저장</app-button>
    </div>
  </div>
</form>
